<template>
    <div class="add-class-wrapper">
        <TitleBaseBox :title="title" @close="close" @cancel="cancelClick" @confirm="confirmClick">
            <div class="content">
                <div class="input-wrapper">
                    <input :placeholder="$t('zhiji.knowlege.classifyHolder')" v-model="className" />
                    <DeleteIcon class="input-delete-icon" @iconClick="iconClick" v-show="showIcon" />
                </div>
                <div class="item-line" v-if="showRadio">
                    <span class="item-line-label">
                        <span>{{  $t('zhiji.knowlege.treeModal.isLikeDisplay') }}</span>
                        <el-tooltip class="item" effect="dark" :content="$t('zhiji.knowlege.treeModal.isLikeDisplayTips')" placement="bottom">
                        <i class="el-icon-question tips-icon"></i>
                        </el-tooltip>
                    </span>
                    <el-radio-group v-model="isLikeDisplay">
                        <el-radio :label="1">{{ $t('zhiji.common.yes') }}</el-radio>
                        <el-radio :label="0">{{ $t('zhiji.common.no') }}</el-radio>
                    </el-radio-group>
                </div>
                <div class="item-line" v-if="showRadio">
                    <span class="item-line-label">
                        <span>{{ $t('zhiji.knowlege.treeModal.isConsidered') }}</span>
                        <el-tooltip class="item" effect="dark" :content="$t('zhiji.knowlege.treeModal.isConsideredTips')" placement="bottom">
                        <i class="el-icon-question tips-icon"></i>
                        </el-tooltip>
                    </span>
                    <el-radio-group v-model="isConsidered">
                        <el-radio :label="1">{{ $t('zhiji.common.yes') }}</el-radio>
                        <el-radio :label="0">{{ $t('zhiji.common.no') }}</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import { updataTreeData } from "@/views/zhiji/js/common/util.js";

export default {
    name: "AddClassification",
    props: ["data"],
    components: {
        TitleBaseBox,
        DeleteIcon
    },
    data() {
        return {
            className: this.data.opr === 'edit' ? this.data.label : "",
            isLikeDisplay: this.data.opr === 'edit' ? this.data.isLikeDisplay : 1,
            isConsidered: this.data.opr === 'edit' ? this.data.isConsidered : 1,
            treeData: this.$store.state.zhiji.questionListPage.treeData.children
        };
    },
    computed: {
        title() {
            const upperNumber = {
                0: this.$t("zhiji.category.first"),
                1: this.$t("zhiji.category.second"),
                2: this.$t("zhiji.category.third")
            };
            let arr = this.data.path ? this.data.path.split("/") : [];
            if (this.data.opr === 'add') {
                return upperNumber[arr.length];
            } else if (this.data.opr === 'edit') {
                // 只有一级标签编辑才显示弹窗
                return this.$t("zhiji.category.editFirst");
            }
        },
        showIcon() {
            return this.className != "";
        },
        showRadio() {
            // 只有一级标签才显示踩赞选项
            if (this.data.opr === 'add' && this.data.isRoot) {
                return true;
            } else if (this.data.opr === 'edit' && this.data.level === 1) {
                return true;
            }
            return false;
        },
    },
    methods: {
        iconClick() {
            this.className = "";
        },
        cancelClick() {
            this.close();
        },
        confirmClick() {
            let arr = this.data.path.split("/");
            if (this.data.opr === 'add') {
                // 新增
                let treeData = {
                    classId: this.data.path ? arr[arr.length - 1] : this.data.path,
                    label: this.className,
                    setLevel: this.data.isRoot ? 1 : arr.length + 1,
                    isLikeDisplay: this.isLikeDisplay,
                    isConsidered: this.isConsidered,
                };
                this.$store.dispatch("zhiji/addQuestionTrees", treeData);
            } else if (this.data.opr === 'edit') {
                // 编辑
                updataTreeData(this.treeData, arr, treeData => {
                    treeData.label = this.className;
                    treeData.isLikeDisplay = this.isLikeDisplay;
                    treeData.isConsidered = this.isConsidered;
                    this.$store.dispatch("zhiji/updateQuestionTrees", treeData);
                });
            }

            this.close();
        },
        close() {
            this.$emit("closeModal");
        }
    }
};
</script>

<style lang="less" scoped>
.add-class-wrapper {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .input-wrapper {
        position: relative;

        input {
            width: 348px;
            padding: 5px 9px 6px;
            box-sizing: border-box;
            color: #41475e;
            border: 1px solid #d8e4f0;
            border-radius: 4px;
            padding-right: 35px;
            font-size: 12px;
        }

        .input-delete-icon {
            position: absolute;
            right: 8px;
            top: 50%;
            margin-top: -9px;
        }
    }

    .content {
        padding: 20px 5px 0;
        margin-bottom: 12px;
    }

    .item-line {
        margin-top: 15px;
        .item-line-label {
            margin-right: 20px;
            .tips-icon {
                margin-left: 2px;
                font-size: 14px;
                cursor: pointer
            }
        }
    }
}
</style>
